module.exports = __webpack_public_path__ + "static/reach-logo-34872d872c1542ca24b63ad32e56bdfc.jpeg";